var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1625_79829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91797 5.00977H1.2513C1.03029 5.00977 0.818327 5.09756 0.662046 5.25384C0.505766 5.41012 0.417969 5.62209 0.417969 5.8431V17.5098C0.417969 17.7308 0.505766 17.9427 0.662046 18.099C0.818327 18.2553 1.03029 18.3431 1.2513 18.3431H15.418C15.639 18.3431 15.8509 18.2553 16.0072 18.099C16.1635 17.9427 16.2513 17.7308 16.2513 17.5098V15.8431",
    fill: "currentColor",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91797 5.00977H1.2513C1.03029 5.00977 0.818327 5.09756 0.662046 5.25384C0.505766 5.41012 0.417969 5.62209 0.417969 5.8431V17.5098C0.417969 17.7308 0.505766 17.9427 0.662046 18.099C0.818327 18.2553 1.03029 18.3431 1.2513 18.3431H15.418C15.639 18.3431 15.8509 18.2553 16.0072 18.099C16.1635 17.9427 16.2513 17.7308 16.2513 17.5098V15.8431",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5846 14.5749C19.5846 14.9064 19.4529 15.2243 19.2185 15.4588C18.9841 15.6932 18.6662 15.8249 18.3346 15.8249H4.16797C3.83645 15.8249 3.51851 15.6932 3.28409 15.4588C3.04966 15.2243 2.91797 14.9064 2.91797 14.5749V2.9082C2.91797 2.74405 2.9503 2.58151 3.01312 2.42985C3.07594 2.27819 3.16801 2.14039 3.28409 2.02432C3.51851 1.7899 3.83645 1.6582 4.16797 1.6582H18.3346C18.6662 1.6582 18.9841 1.7899 19.2185 2.02432C19.4529 2.25874 19.5846 2.57668 19.5846 2.9082V14.5749Z",
    fill: "currentColor",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91797 3.95047L10.9646 11.403C11.0419 11.4754 11.1438 11.5157 11.2496 11.5157C11.3555 11.5157 11.4574 11.4754 11.5346 11.403L19.5846 3.74964V2.90714C19.5846 2.73249 19.5479 2.55979 19.477 2.40019C19.4061 2.24058 19.3025 2.0976 19.173 1.98047L11.2513 9.58297L3.28797 2.02047C3.17064 2.13639 3.07751 2.27446 3.01399 2.42667C2.95048 2.57889 2.91784 2.7422 2.91797 2.90714V3.95047Z",
    fill: "currentColor",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5846 14.5749C19.5846 14.9064 19.4529 15.2243 19.2185 15.4588C18.9841 15.6932 18.6662 15.8249 18.3346 15.8249H4.16797C3.83645 15.8249 3.51851 15.6932 3.28409 15.4588C3.04966 15.2243 2.91797 14.9064 2.91797 14.5749V2.9082C2.91797 2.74405 2.9503 2.58151 3.01312 2.42985C3.07594 2.27819 3.16801 2.14039 3.28409 2.02432C3.51851 1.7899 3.83645 1.6582 4.16797 1.6582H18.3346C18.6662 1.6582 18.9841 1.7899 19.2185 2.02432C19.4529 2.25874 19.5846 2.57668 19.5846 2.9082V14.5749Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1654 2.07422L11.2487 9.57422L3.33203 2.07422",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1625_79829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message_icon.e97ac2bb90a4c30e43ae72122408c42b.svg";
export { ForwardRef as ReactComponent };